import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AiUsagePage } from '@/features/ai-usage/AiUsagePage';
import { AiToolsPage } from '@/features/ai-tools/AiToolsPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { ResourcesPage } from '@/features/resources/ResourcesPage';
import { BusinessPage } from '@/features/business/BusinessPage';
import { FacilityDetailPage } from '@/features/business/pages/FacilityDetailPage';
import { OrgDetailPage } from '@/features/business/pages/OrgDetailPage';
import { IncidentsPage } from '@/features/incidents/IncidentsPage';
import { ApprovalsPage } from '@/features/elevation/ApprovalsPage';
import { ElevationPage } from '@/features/elevation/ElevationPage';
import { HistoryPage } from '@/features/elevation/HistoryPage';
import { useEnvStore } from '@/env/envStore';

export function AppRoutes() {
  const isCorp = useEnvStore((s) => s.env === 'corp');
  const location = useLocation();

  // Corp is a corp-level context with no EHR product resources — it surfaces
  // only the developer-AI tool spend dashboard, and everything else redirects
  // there.
  if (isCorp) {
    return (
      <Routes>
        <Route path="/ai-tools" element={<AiToolsPage />} />
        <Route path="*" element={<Navigate to={`/ai-tools${location.search}`} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/application-health" element={<Navigate to={`/?tab=application${location.search ? `&${location.search.slice(1)}` : ''}`} replace />} />
      <Route path="/dependency-health" element={<Navigate to={`/?tab=dependency${location.search ? `&${location.search.slice(1)}` : ''}`} replace />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/resources/:resourceId" element={<ResourcesPage />} />
      <Route path="/business" element={<BusinessPage />} />
      <Route path="/business/organizations/:orgId" element={<OrgDetailPage />} />
      <Route path="/business/facilities/:facilityId" element={<FacilityDetailPage />} />
      <Route path="/incidents" element={<IncidentsPage />} />
      <Route path="/ai-usage" element={<AiUsagePage />} />
      {/* The AI tools dashboard is Corp-only; outside Corp, send users home. */}
      <Route path="/ai-tools" element={<Navigate to={`/${location.search}`} replace />} />
      <Route path="/elevation/approvals" element={<ApprovalsPage />} />
      <Route path="/elevation/history" element={<HistoryPage />} />
      <Route path="/elevation" element={<ElevationPage />} />
      <Route path="/elevation/:requestId" element={<ElevationPage />} />
      <Route path="*" element={<DashboardPage />} />
    </Routes>
  );
}
